import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import OrientationOverlay from '../components/OrientationOverlay';
import StoryContent from '../components/StoryContent';
import StoryHeader from '../components/StoryHeader';
import StoryNavBar from '../components/StoryNavBar';

const LANDSCAPE_RATIO_THRESHOLD = 1;
const LAPTOP_MIN_WIDTH = 1024;

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  const isLandscapeMode = width / height >= LANDSCAPE_RATIO_THRESHOLD;
  const isMobileLandscape = isLandscapeMode && height < 550;
  const isLaptop = width >= LAPTOP_MIN_WIDTH;

  return { isLandscapeMode, isMobileLandscape, isLaptop };
}

export default function Story({ guestDetails, pages }) {
  const location = useLocation();
  const navigate = useNavigate();
  const initialIndex = location.state?.pageIndex ?? 0;
  const [currentPageIndex, setCurrentPageIndex] = useState(initialIndex);
  const [{ isLandscapeMode, isMobileLandscape, isLaptop }, setDimensions] =
    useState(getWindowDimensions());

  useEffect(() => {
    navigate('.', { replace: true, state: null });
  }, [navigate]);

  useEffect(() => {
    const handleResize = () => setDimensions(getWindowDimensions());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const page = pages[currentPageIndex];

  return (
    <div className="fixed inset-0 w-screen h-[100dvh] bg-slate-900 flex items-center justify-center overflow-hidden">
      {/* LANDSCAPE OVERLAY FOR MOBILE PHONES */}
      <OrientationOverlay isVisible={isMobileLandscape} />

      {/* Container simulating mobile frame on laptop, full width on iPads and phones */}
      <div
        className={`relative w-full h-full bg-wedding-blush flex flex-col overflow-hidden shadow-2xl ${
          isLaptop ? 'max-w-[480px]' : ''
        }`}
      >
        {/* HEADER AT THE TOP */}
        <StoryHeader />

        {/* CONTENT AREA */}
        <StoryContent
          page={page}
          currentPageIndex={currentPageIndex}
          isLandscapeMode={isLandscapeMode}
        />

        {/* BOTTOM NAVIGATION BAR */}
        <StoryNavBar
          pages={pages}
          currentPageIndex={currentPageIndex}
          onSelectPage={(index) => setCurrentPageIndex(index)}
        />
      </div>
    </div>
  );
}
